import { useLazyQuery, useMutation, useQuery } from '@apollo/client';
import { Box } from '@material-ui/core';
import ButtonContinue from 'component/customize_style_component/button_continue';
import { TextErr } from 'component/customize_style_component/styled_title';
import { useAuth } from 'contexts/AuthContext';
import { CREATE_ANSWER } from 'graph_ql/getQuiz/mutation';
import { GET_QUESTION_DATA, GET_QUIZ_RESPONSE } from 'graph_ql/getQuiz/queries';
import { useCallback, useEffect, useMemo, useState } from 'react';
import Div100vh from 'react-div-100vh';
import { useHistory } from 'react-router-dom';
import { PATH } from 'routes/constant';
import { EQuestionId, EQuizId, ESubjectQuestion, quizContextType } from 'types/quiz';
import { GenderItem } from './single_item';
import commonStyle from '../quiz.module.scss';
import ProgressBar from 'component/progress_bar';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { UserQuizStatus } from '..';
import { STRINGS } from '../../../constants/strings';
import { LOCAL_STORAGE_KEY } from 'utils/constant';
import { USER_DETAIL } from 'graph_ql/authentication/queries';
import { useDispatch } from 'react-redux';
import { getMe } from 'redux/authentication/user_detail';
import { handleGenderMismatchEvent } from 'containers/authentication/useAuthenticate';

const ImageSingleSelect = () => {
    const { currentUser } = useAuth();
    const history = useHistory();
    const dispatch = useDispatch();
    const [data, setData] = useState<any>([]);
    const [quizData, setQuizData] = useState<any>(null);
    const pendingQuizObj = useSelector((state: RootState) => state.userDetail.pendingQuizzes);
    const userQuizzes =
        pendingQuizObj?.hasOwnProperty('getPendingQuizzes') && pendingQuizObj?.getPendingQuizzes?.quizConfigs;
    const pendingQuizzes =
        userQuizzes && userQuizzes?.filter((item) => item.status === UserQuizStatus.pending && !item.conditionQuiz);
    const withGenderQuizLength = userQuizzes.length + 1;
    const completedQuizPercentage = pendingQuizzes?.length
        ? ((withGenderQuizLength - pendingQuizzes.length) / withGenderQuizLength) * 100
        : 0;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { data: _dataGender } = useQuery(GET_QUESTION_DATA, {
        variables: {
            input: {
                subject: ESubjectQuestion.GENDER,
                paging: {
                    size: 2,
                    page: 0,
                },
            },
        },
        onCompleted(data) {
            setData(
                data.getQuestionData.data.map((item) => {
                    return {
                        ...item,
                        isSelect: false,
                    };
                }),
            );
        },
        skip: !currentUser?.uid,
    });

    const createAnswer = (input: {
        questionId: String;
        questionSubject: String;
        contextType: String;
        contextId: String;
        value: String;
        valueType: String;
    }) => {
        const variables = {
            input,
        };
        answerMutation({ variables });
    };
    const [answerMutation, { loading: loadingAnswer }] = useMutation(CREATE_ANSWER, {
        onCompleted() {
            onAnswerCompleted();
        },
        onError(error) {
            console.log('Create Failed: ', error);
        },
    });

    const [dataConfig] = useLazyQuery(USER_DETAIL, {
        onCompleted(response) {
            dispatch(getMe(response.me));
            if (response?.me?.gender) {
                handleGenderMismatchEvent(response?.me);
            }
        },
    });

    const onAnswerCompleted = async () => {
        dataConfig();
        await getQuizResponse();
        history.push(`${PATH.QUIZ_MANAGER}/?signup=${Date.now()}`);
    };

    const [getQuizResponse] = useLazyQuery(GET_QUIZ_RESPONSE, {
        variables: {
            input: {
                quizId: EQuizId.GENDER_QUIZ,
                contextType: quizContextType,
                contextId: EQuizId.GENDER_QUIZ,
                userId: currentUser?.uid,
            },
        },
        onCompleted(data) {
            setQuizData(data.getQuizResponse);
            console.log(data.getQuizResponse.questions.gender_question);
        },
    });
    useEffect(() => {
        if (currentUser?.uid) {
            getQuizResponse();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentUser?.uid]);

    const validAnswer = useMemo(() => {
        const foundSelectedItem = data.find((item) => item.isSelect);
        return foundSelectedItem ? true : false;
    }, [data]);

    const handleClick = useCallback(
        (item) => {
            setData(
                data.map((d) => {
                    d.isSelect = item.id === d.id;
                    return d;
                }),
            );
        },
        [data],
    );

    useEffect(() => {
        if (data.length) {
            const optionSelected = data.find((item) => item.isSelect);
            const localUserGender = JSON.parse(
                localStorage.getItem(LOCAL_STORAGE_KEY.LOCAL_USER_KEY) as string,
            )?.gender;
            if (!optionSelected && localUserGender) {
                const defaultOption = data.find((item) => item.value === localUserGender);
                handleClick(defaultOption);
            }
        }
    }, [data, handleClick]);

    const [error, setError] = useState(false);
    const handleClickAnswer = () => {
        const option = data.find((item) => item.isSelect);
        if (option) {
            const input = {
                questionId: EQuestionId.GENDER,
                questionSubject: ESubjectQuestion.GENDER,
                contextType: quizContextType,
                contextId: EQuizId.GENDER_QUIZ,
                value: option.value,
                valueType: 'STRING',
            };
            createAnswer({ ...input, value: option.value });
        } else {
            setError(true);
        }
    };
    useEffect(() => {
        if (data?.length && data.find((d) => d.isSelect)) setError(false);
    }, [data]);
    return (
        <Div100vh
            style={{
                background: 'rgb(242, 242, 242)',
            }}
        >
            <Box textAlign={'center'} pt={'12px'}>
                <div className={commonStyle.mainTitle}>Gender</div>
            </Box>
            <ProgressBar completedPercentage={completedQuizPercentage} />
            <div style={{ marginTop: 24, marginLeft: 10, marginRight: 10 }} className={commonStyle.subtitle}>
                {quizData?.subTitle}
            </div>
            <div
                style={{
                    width: 'auto',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginTop: 24,
                }}
            >
                {data?.length > 0 &&
                    data.map((item, index) => (
                        <GenderItem
                            key={index}
                            handleClick={() => handleClick(item)}
                            isSelect={item.isSelect}
                            name={item.title}
                            image={item.imageUrl}
                        />
                    ))}
            </div>
            {error && (
                <Box width={'100%'} textAlign="center">
                    <TextErr>Please select your gender.</TextErr>
                </Box>
            )}
            <ButtonContinue
                isDisabled={!validAnswer}
                handleClick={handleClickAnswer}
                content={STRINGS.SAVE}
                isHiddenArrow
                loading={loadingAnswer}
            />
        </Div100vh>
    );
};
export default ImageSingleSelect;
